import { PersonArtistType } from '@api';
import { ArtistAnchor } from '@common';
import { Stack } from '@mantine/core';

type ArtistsPropsType = {
  artists: PersonArtistType[];
};

export const Artists: React.FC<ArtistsPropsType> = ({ artists }) => {
  return (
    <Stack gap={0}>
      {artists.map((artist) => (
        <ArtistAnchor key={artist.id} artist={artist} />
      ))}
    </Stack>
  );
};
